import { render } from "./HeroiconsOutlineDocumentRemove.vue?vue&type=template&id=2d8d84b7"
const script = {}

import exportComponent from "/home/roland/vscode/diablo/newsroom/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineDocumentRemove.vue"]])

export default __exports__